import { GameStage } from '../../model/enumeration/GameStage.enum';
import { PlayerActionType } from '../../model/enumeration/PlayerActionType.enum';
import { LogEvent } from '../../model/LogsResponse';
import { Player } from '../../model/Player';
import eventLogsStore from '../../store/EventLogsStore';
import gameStore from '../../store/GameStore';
import playerActionStore from '../../store/PlayerActionStore';
import playerStore from '../../store/PlayerStore';
import { WEvent } from './WEvent';

export class WPlayerEvent extends WEvent {
  gameId: string;
  pid: string;

  stage: GameStage;

  gamePot: number;

  playerAction: PlayerActionType;
  bet: number;
  totalBet: number;
  stack: number;
  allIn: boolean;

  constructor(event: WPlayerEvent) {
    super(event.tableId, event.eventType, event.eventTime);
    Object.assign(this, event);
  }

  applyWebsocketChanges = (): Promise<void> =>
    gameStore.findActiveGame(this.tableId).then(game => {
      game.setPlayers(
        playerStore.modifyPlayers(game.players, this.pid, player => {
          player.stack = this.stack;
          player.totalBet = this.totalBet;
          player.allIn = this.allIn;
          player.notParticipating = false;
          if (this.playerAction === PlayerActionType.FOLD) {
            player.folded = true;
          }
          this.addEventToLog(player);
          playerActionStore.addPlayerAction({
            pid: this.pid,
            action: this.playerAction,
            bet: this.bet,
            tableId: this.tableId,
          });
        }),
      );
      game.setPot(this.gamePot);
      game.resetActivePlayer();
    });

  private addEventToLog = (player: Player): void => {
    const eventLog = { blinds: [] } as LogEvent;
    eventLog.pid = this.pid;
    eventLog.nick = player.nick;
    eventLog.blinds = player.blinds;
    eventLog.value = this.bet;
    eventLog.allIn = this.allIn;
    eventLog.myBot = player.myBot;
    eventLog.action = this.playerAction;
    eventLog.pot = this.gamePot;
    eventLogsStore.addEventToLog(this.tableId, eventLog, this.stage);
  };
}
